import { ComponentType } from 'react';
// import ApprovedUsedBanner from './approvedUsedBanner';
import BestDealGuaranteeBanner from './bestDealGuaranteeBanner';
import BigYellowVoucher from './bigYellowVoucher';
// import BlackFridayBanner from './blackFridayBanner';
import ChargeBanner from './chargeBanner';
import DealDropBanner from './dealDropBanner';
import EvBMWChargerBanner from './evBMWChargerBanner';
import EvChargerBanner from './evChargerBanner';
// import EvGrantBanner from './evGrantBanner';
import ExternalEvGrantBanner from './externalEvGrantBanner';
// import LuxeBanner from './luxeBanner';
import RewardsWeekBanner from './rewardsWeekBanner';
// import SpotlightSaleBanner from './spotlightSaleBanner';
// import RealSaleBanner from './realSaleBanner';
import UpgradeBanner from './upgradeBanner';

// Register banners here
// template_name : Component
export const BannerRegistry = {
  // approved_used_banner: ApprovedUsedBanner,
  best_deal_guarantee_banner: BestDealGuaranteeBanner,
  big_yellow_voucher: BigYellowVoucher,
  // black_friday_banner: BlackFridayBanner,
  charge_banner: ChargeBanner,
  deal_drop_banner: DealDropBanner,
  ev_bmw_charger_banner: EvBMWChargerBanner,
  ev_charger_banner: EvChargerBanner,
  external_ev_grant_banner: ExternalEvGrantBanner,
  // luxe_banner: LuxeBanner,
  // realsale_banner: RealSaleBanner,
  rewards_week_banner: RewardsWeekBanner,
  // spotlight_sale_banner: SpotlightSaleBanner,
  upgrade_banner: UpgradeBanner,
  // used_ev_grant_banner: EvGrantBanner,
} as const;

// Type representation of BannerRegistry
// So we can get the banner types from the registry
export type Registry = typeof BannerRegistry;

// Extracts the props from a react component
type PropsOf<T> = T extends ComponentType<infer P> ? P : never;

// Match template to props - If this template, then these props
// { template: 'template_name' } & Props
export type BannerProps = {
  [K in keyof Registry]: { template: K } & PropsOf<Registry[K]>;
}[keyof Registry];
